<template>
  <div>
    <div class="flex flex-row expand-children mb-4">
      <div class="flex-1">
        <b>Lessons</b>
      </div>
      <div class="flex-1">
        <b>Start date</b>
      </div>
      <div class="flex-1">
        <b>End date</b>
      </div>
      <div class="flex-1">
        <b>Score</b>
      </div>
    </div>

    <div v-for="lesson in lessonList" :key="lesson.lessonId" class="flex flex-row expand-children">
      <div class="flex-1">
        <p class="text-lg">
          {{ lesson.lessonName }}
          <el-tooltip v-if="lesson.formerLessonName != null" placement="top">
            <div slot="content">
              Formerly known as
              <strong class="text-warning">{{ lesson.formerLessonName }}</strong><br>
            </div>
            <i class="text-info fa-solid fa-circle-info" @click="openFormerNameModal(lesson)"></i>
          </el-tooltip>
        </p>
      </div>
      <template v-if="lesson.score">
        <div class="flex-1">
          <p class="text-lg">
            {{ formatDateTime(lesson.score.started_at) }}
          </p>
        </div>
        <div class="flex-1">
          <p class="text-lg">
            {{ formatDateTime(lesson.score.completed_at) }}
          </p>
        </div>
        <div class="flex-1">
          <b v-if="lesson.lessonHasExam" class="text-lg text-info cursor-pointer" @click="openScore(lesson)">
            {{ parseScore(lesson.score) }}
          </b>
          <b v-if="!lesson.lessonHasExam" class="text-lg"> N/A </b>
        </div>
      </template>
    </div>
    <!-- Modal -->
    <el-dialog
      :modal="false"
      title="Former Lesson Name"
      :visible="showFormerNameModal"
      width="40%"
      center
      @close="handleModalClose"
      @update:visible="handleModalVisibility"
    >
      <div v-if="selectedLesson" style="text-align: center;">
        <p><strong>Current Name:</strong> {{ selectedLesson.lessonName }}</p>
        <p><strong>Former Name:</strong> {{ selectedLesson.formerLessonName }}</p>
        <p>This lesson was renamed to better reflect its updated content.</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="closeFormerNameModal">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog } from 'element-ui';
import HelperDate from "@helpers/dates";
import ScoreComponent from "@components/Dashboard/Views/Pages/Training/Record/Components/ScoreComponent";

export default {
  components: {
    'el-dialog': Dialog,
  },
  props: {
    lessonList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modal: {},
      showFormerNameModal: false,
      selectedLesson: null,
    };
  },
  computed: {
  },
  methods: {
    openFormerNameModal(lesson) {
      this.selectedLesson = lesson;
      this.showFormerNameModal = true;
    },
    closeFormerNameModal() {
      this.showFormerNameModal = false;
      this.selectedLesson = null;
    },
    handleModalClose() {
      this.showFormerNameModal = false;
      this.selectedLesson = null;
    },
    handleModalVisibility(visible) {
      this.showFormerNameModal = visible;
      if (!visible) {
        this.selectedLesson = null;
      }
    },
    async openScore(lesson) {
      return this.$modal.show(ScoreComponent, { lesson: lesson });
    },
    formatDateTime(date) {
      return HelperDate.formatDateTime(date);
    },
    parseScore(score) {
      return `${score.correctQuestions}/${score.totalQuestions} corrected to 100%`;
    },
  },
};
</script>

<style lang="scss">
.clickable-icon {
  cursor: pointer;
  margin-left: 8px;
  color: #409EFF;
  transition: color 0.3s;
}

.clickable-icon:hover {
  color: #66b1ff;
}
</style>
